import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import MarkdownIt from 'markdown-it';

import guideData from '../data/guide';

import './guide.component.css';

export default class GuideComponent extends React.Component {
	render () {
		return (
			< div className = "id-guide" >
				< nav className = "bd-nv" >
					< ul className = "bn-nl" >
						{
							guideData.map( ( item, key ) => (
								< li className = { [ 'bn-ni' ].concat( this.props.params.id === item.id ? [ 'bn-nc' ] : [] ).join(' ') } key = { key } >
									< div className = "bn-nt" >
										{
											item.id ? (
												< Link to = { `/guide/${ item.id }` } title = { item.name } className = "bn-nt" >
													< span className = "bn-ct" >{ item.name }< /span >
												< /Link >
											) :
											item.name
										}
									< /div >

									{
										item.children &&
										item.children.length > 0 &&

										< ul className = "bn-cl" >
											{
												item.children.map( ( item, key ) => (
													< li className = { [ 'bn-ci' ].concat( this.props.params.id === item.id ? [ 'bn-cc' ] : [] ).join(' ') } key = { key } >
														< Link to = { `/guide/${ item.id }` } title = { item.name } >
															< span className = "bn-ct" >{ item.name }< /span >
														< /Link >
													< /li >
												) )
											}
										< /ul >
									}
								< /li >
							) )
						}
					< /ul >
				< /nav >

				< GuideMainComponent id = { this.props.params.id } / >
			< /div >
		);
	}
};

function GuideMainComponent( props ) {
	var id = props.id;

	var data;

	try {
		if ( !id )
			id = guideData.filter( item => item.id )[ 0 ].id;

		data = require.context( '../data/guide', true, /\.\/.+\.md$/ )( `./${ id }.md` );
	}
	catch ( e ) {
		return null;
	}

	if ( !data )
		return null;

	const md = new MarkdownIt;

	data = md.render( data );

	return (
		< div className = "bd-mn" >
			< div className = "bm-md" dangerouslySetInnerHTML = { { __html: data } } / >
		< /div >
	);

	return null;
}



/** WEBPACK FOOTER **
 ** ./app/components/guide.component.js
 **/